import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 0 20px 40px;

  @media (max-width: 480px) {
    padding: 0 12px 32px;
  }
`;

export const PageBanner = styled.div`
  padding: 24px 0 18px;

  .page-title {
    font-size: 15px;
    font-weight: 800;
    color: #f1f5f9;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    svg { color: #9333EA; }
  }

  .page-sub {
    font-size: 12.5px;
    color: #6b7280;
  }
`;

export const TalentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 16px;
`;

export const TalentCard = styled.div`
  display: block;
  text-decoration: none;
  cursor: pointer;
  background: #1A1A1A;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  }

  .cover {
    width: 100%;
    aspect-ratio: 16/10;
    background: #0a0a14;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .no-image {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #374151;
      font-size: 28px;
    }
  }

  .card-body {
    padding: 14px 16px 16px;
  }

  .talent-name {
    font-size: 14px;
    font-weight: 800;
    color: #e2e8f0;
    margin-bottom: 6px;
  }

  .talent-desc {
    font-size: 12px;
    color: #9ca3af;
    line-height: 1.55;
    margin-bottom: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .react-row {
    display: flex;
    gap: 8px;
  }

  .react-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: #111;
    color: #9ca3af;
    font-family: inherit;
    font-size: 12.5px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.18s;

    svg { font-size: 14px; }

    &:hover { border-color: rgba(255, 255, 255, 0.18); color: #e2e8f0; }

    &.active-like { background: rgba(22, 163, 74, 0.14); border-color: rgba(74, 222, 128, 0.3); color: #4ade80; }
    &.active-dislike { background: rgba(239, 68, 68, 0.14); border-color: rgba(248, 113, 113, 0.3); color: #f87171; }

    &.locked { cursor: not-allowed; opacity: 0.6; }
  }
`;
